import { motion } from 'framer-motion';
import clsx from 'clsx';
import { ReactComponent as SunSVG } from '../../assets/sun.svg';
import style from './style.module.scss';

const Sun = () => (
    <motion.div
        className={clsx(style.sun, style.sunOnMobile)}
        initial={{ rotate: -30 }}
        whileInView={{ rotate: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2 }}
    >
        <SunSVG />
    </motion.div>
);

export default Sun;
